import { publishFormSubmitted } from 'utils/form-analytics';

type HubSpotLegacyMessage = {
  type?: string;
  eventName?: string;
  id?: string;
  data?: {
    submissionValues?: {
      email?: string;
    };
  };
};

const installHubSpotLegacyListener = (): void => {
  window.addEventListener('message', (event) => {
    const data = event.data as HubSpotLegacyMessage | undefined;
    if (data?.type !== 'hsFormCallback') return;
    if (data.eventName !== 'onFormSubmitted') return;

    publishFormSubmitted('hubspot', data.data?.submissionValues?.email, data.id);
  });
};

const installHubSpotV4Listener = (): void => {
  window.addEventListener('hs-form-event:on-submission:success', (event) => {
    const hubspotForms = window.HubSpotFormsV4;
    if (!hubspotForms) return;

    const form = hubspotForms.getFormFromEvent(event);
    if (!form) return;

    void form.getFormFieldValues().then((values) => {
      const emailField = values.find((field) => /email/i.test(field.name));
      const formId = typeof form.getFormId === 'function' ? form.getFormId() : undefined;

      publishFormSubmitted('hubspot', emailField?.value, formId);
    });
  });
};

installHubSpotLegacyListener();
installHubSpotV4Listener();
